import { action } from 'mobx';

import { AppManager, Input } from 'core/index';

import { CommentApp } from 'apps/comments/app';
import { CommentMutation } from 'apps/comments/gql';

export class CommentFormAppManager extends AppManager {
  static registryName = 'CommentFormAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    let inSpace = init.props.content?.inSpace;
    // FIXME - temporary solution for comments on Stories.

    // Stories don't have an space of their own, so
    // their space and inSpace point to the creator's profile.
    // This means file uploads linked to comments, made by users
    // other that the Story's creator themself will fail.

    // As a temporary solution, we check if the content to be commented on
    // is a Story, in that case we don't indicate an inSpace so the
    // Editor's FileAppManager will take the current logged in user.

    if (init.props.content?.constructor?.name === 'StoryApp') {
      inSpace = undefined;
    }
    this.commentFormApp = new CommentApp(this, { inSpace });
    this.commentFormApp.Edit();
    this.commentFormInput = new Input({
      origin: () => init.props.content?.id,
      body: () => this.commentFormApp.body,
    });
    this.commentsConnection = init.commentsConnection;
  }

  @action Submit = options => {
    this.mutations.push(CommentMutation.New(this.commentFormInput, options));
  };

  @action UpdateComment = (input, options) => {
    this.mutations.push(CommentMutation.New(input, options));
  };
}
